// extracted by mini-css-extract-plugin
export default {"mCard":"qz-z","image":"rz-z","imageNoBackground":"sz-z","imageHasCategory":"tz-z","fullWidth":"uz-z"};